"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = boot;
function boot(options) {
    const { logger } = options;
    logger.info('Booting...');
}
